import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetSettlements = (params) => axios.get(apiPaths.settlementsBase, { params });
const onCreateSettlement = (settlement) => axios.post(apiPaths.settlementsBase, settlement);
const onUpdateSettlement = (settlement) => axios.put(`${apiPaths.settlementsBase}/${settlement.id}`, settlement);

const onGetCutbackReasons = (params) => axios.get(apiPaths.cutbackReasonsBase, { params });
const onCreateCutbackReason = (reason) => axios.post(apiPaths.cutbackReasonsBase, [{ reason }]);

const onGetSettlementPdfSummary = (settlementId) =>
  axios.get(`${apiPaths.settlementsBase}/${settlementId}/pdf-summary`, {
    responseType: 'blob',
    headers: { Accept: 'application/pdf' }
  });

const onExportSettlements = (params) =>
  axios.post(`${apiPaths.reportingBase}/settlements/create-export-file`, null, { params, responseType: 'arraybuffer' });

export {
  onCreateSettlement,
  onUpdateSettlement,
  onGetSettlements,
  onGetCutbackReasons,
  onCreateCutbackReason,
  onGetSettlementPdfSummary,
  onExportSettlements
};
